import { FormlyFieldConfig } from '@ngx-formly/core';
import {
	namePattern,
} from '@lmc-app/summary/details/details-form-helpers';
import { RapidApplicationFormOptions } from './rapid-application-form-options.interface';
/**
 * Main configuration builder for the application form
 *
 * @param options - Options containing observables for dropdowns and callback functions
 * @returns Complete application form configuration
 */
export function buildRapidApplicationFormConfig(
	options: RapidApplicationFormOptions,
): FormlyFieldConfig[] {
	return [
		{
			fieldGroupClassName: 'row',
			fieldGroup: [
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'first_name',
					type: 'input',
					props: {
						label: 'First name',
						required: true,
					},
					validators: {
						namePattern: {
							expression: (c: { value: string }) => !c.value || namePattern.test(c.value),
							message: 'Cannot contain digits or start/end with special characters',
						},
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'middle_name',
					type: 'input',
					props: {
						label: 'Middle name',
					},
					validators: {
						namePattern: {
							expression: (c: { value: string }) => !c.value || namePattern.test(c.value),
							message: 'Cannot contain digits or start/end with special characters',
						},
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'last_name',
					type: 'input',
					props: {
						label: 'Last name',
						required: true,
					},
					validators: {
						namePattern: {
							expression: (c: { value: string }) => !c.value || namePattern.test(c.value),
							message: 'Cannot contain digits or start/end with special characters',
						},
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'sin',
					type: 'sin',
					props: {
						label: 'SIN',
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'telephone',
					type: 'phone',
					props: {
						label: 'Phone number',
						required: true,
					},
				},
				{
					className: 'col-12 col-sm-6 col-lg-4',
					key: 'dob',
					type: 'datepicker',
					props: {
						label: 'Date of Birth',
						required: true,
					},
				},
				{
					className: 'col-12 col-lg-8',
					key: 'street',
					type: 'google-address',
					props: {
						label: 'Address',
						onAddressSelect: (result: any) =>
							options.onAddressSelect(result),
					},
				},
				{
					className: 'col-12 col-sm-6 col-lg-4',
					key: 'address2',
					type: 'input',
					props: {
						label: 'Address 2',
					},
				},
				{
					className: 'col-12 col-sm-6 col-lg-4',
					key: 'city',
					type: 'input',
					props: {
						label: 'City',
					},
				},
				{
					className: 'col-12 col-sm-6 col-lg-4',
					key: 'province',
					type: 'input',
					props: {
						label: 'Province',
					},
				},
				{
					className: 'col-12 col-sm-6 col-lg-4',
					key: 'postal_code',
					type: 'postal-code',
					props: {
						label: 'Postal Code',
					},
				},
			],
		},
	];
}
